module.exports = __webpack_public_path__ + "img/clover_club.62044bd2.jpg";